<template>
    <div class="template-messages">
        <TemplateMessageModal
            v-if="templateMessageModal"
            :template="templateMessageModal"
            :channel-id="contact.channel"
            @close="templateMessageModal = null"
            @send="sendTemplate"
        />
        <div class="empty" v-if="channels.length === 0">
            <div class="title">Whatsapp Kanalı Bulunamadı</div>
            <div class="message">Sistem üzerinde bir whatsapp kanalı bulunamadı.</div>
        </div>
        <template v-else>
            <div class="items">
                <div v-if="channelTemplates.length <= 0">Template bulunamadı</div>
                <div
                    class="item-card"
                    v-for="(item, index) of channelTemplates"
                    :data-id="item._id"
                    :data-pointer="index"
                    :key="item._id"
                    @click="useTemplate(item)"
                    :class="{
                        selected: pointerIndex === index,
                        hoverSelected: pointerIndex === index,
                    }"
                >
                    <div class="title-wrapper">
                        <div class="title">
                            {{ item.elementName }}
                        </div>
                    </div>
                    <div class="message-preview">
                        {{ item.data }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import log2 from "../../../../../../utils/log2";
import TemplateMessageModal from "./TemplateMessageModal.vue";

const log = log2("TemplateMessages");
export default Vue.extend({
    name: "TemplateMessages",
    components: { TemplateMessageModal },
    data() {
        return {
            pointerIndex: 0,
            cancels: [],
            channelTemplates: [],
            templateMessageModal: null,
        };
    },
    props: {
        defaultSearch: {
            type: String,
        },
        type: {
            type: String,
        },
        contact: {
            type: Object,
        },
    },
    computed: {
        ...mapState({
            businessTemplates: (state) => state.whatsapp.templates,
            channels: (state) => state.channel.channels.filter((channel) => channel.type === "whatsapp-business-api"),
        }),
    },
    async mounted() {
        this.getTemplates(this.contact.channel);
        const channel = this.channels.find((channel) => channel._id === this.contact.channel);
        const initialTemplateId = _.get(channel, "payload.initialTemplate.id");
        this.channelTemplates = this.businessTemplates[this.contact.channel] || [];
        const initialTemplate = this.channelTemplates.find((item) => item.id === initialTemplateId);

        if (initialTemplate) {
            this.channelTemplates = [
                initialTemplate,
                ...this.channelTemplates.filter((item) => item.id !== initialTemplateId),
            ];
        }

        const keydownCallback = (e) => {
            console.log("CannedMessageSelector.keydown", e.key);
            if (e.key === "ArrowDown") {
                const index = Math.min(this.pointerIndex + 1, this.channelTemplates.length - 1);
                const id = this.channelTemplates.find((item, i) => i === index)?._id;
                const el = document.querySelector(`div[data-id='${id}']`);
                el?.scrollIntoView({
                    behavior: "smooth",
                });
                this.pointerIndex = index;
            } else if (e.key === "ArrowUp") {
                const index = Math.max(this.pointerIndex - 1, 0);
                const id = this.channelTemplates.find((item, i) => i === index)?._id;
                const el = document.querySelector(`div[data-id='${id}']`);
                el?.scrollIntoView({
                    behavior: "smooth",
                });
                this.pointerIndex = index;
            } else if (e.key === "Enter") {
                const item = this.channelTemplates.find((item, i) => i === this.pointerIndex);
                this.useTemplate(item);
            }
        };
        window.addEventListener("keydown", keydownCallback);
        this.cancels.push(() => window.removeEventListener("keydown", keydownCallback));
    },
    created() {},
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        useTemplate(item) {
            this.templateMessageModal = item;
        },
        sendTemplate(data) {
            this.templateMessageModal = null;
            this.$emit("send", data);
        },
    },
    beforeDestroy() {
        log("beforeDestroy");
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        pointerIndex(val) {
            const el = this.$el.querySelector(`.item-card[data-pointer="${val}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
    },
});
</script>

<style scoped lang="scss">
.template-messages {
    width: 100%;
    display: flex;
    height: 100%;
    min-height: inherit;

    &.search-mode {
        .groups {
            display: none;
        }

        .items {
            width: 100%;
        }
    }

    .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        height: 100%;
        width: 100%;

        .title {
            font-size: 16px;
            font-weight: 700;
            color: #6c757d;
        }

        .message {
            font-size: 14px;
            font-weight: 500;
            color: #6c757d;
        }
    }

    .items {
        display: flex;
        flex-direction: column;
        width: 100%;
        background-color: #fff;
        overflow: auto;

        .item-card {
            display: flex;
            flex-direction: column;
            gap: 3px;
            padding: 5px 5px;
            cursor: pointer;
            border-bottom: 1px solid #f1f4f7;

            &:hover,
            &.selected {
                background-color: #f5f5f5;
            }

            &.hoverSelected {
                box-shadow: 2px 2px 2px 2px var(--color-bg-primary-hover);
            }

            .title-wrapper {
                display: flex;
                justify-content: space-between;

                .title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #6c757d;
                    display: flex;
                    align-items: center;

                    span {
                        display: flex;
                        align-items: center;
                    }
                }

                .shortcut {
                    font-size: 12px;
                    font-weight: 400;
                    color: #6c757d;
                }
            }

            .message-preview {
                font-size: 12px;
                font-weight: 500;
                color: #6c757d;
                -webkit-line-clamp: 2;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                border-left: 3px solid #6c757d;
                padding-left: 3px;
            }
        }
    }
}
</style>
